<template>
  <div ref="projectApply_content" class="projectApply-box">
    <div class="projectApply-headers" :class="'headers-background-'+projectApplyInfo.applyStatus">
      <headers
        :headInfo="{headUrl: projectApplyInfo.dingDingPhotoPath, dingdingUserId:projectApplyInfo.currentApplyDingDingId, userName: projectApplyInfo.currentApplyEmployeeName, approver: projectApplyInfo.nextApprover, approvalState: projectApplyInfo.applyStatus }"
      ></headers>
    </div>
    <div ref="projectApply_tab" class="projectApply-tab">
      <tab :tabconfig="tabconfig"></tab>
    </div>
    <div class="mian-box">
      <div class="projectApply-info d_jump">
        <div class="projectApply-info-content">
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">项目部门</div>
            <div class="projectApply-info-value">{{projectApplyInfo.deptName}}</div>
          </div>
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">项目名称</div>
            <div class="projectApply-info-value">{{projectApplyInfo.projectName}}</div>
          </div>
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">项目编号</div>
            <div class="projectApply-info-value">{{projectApplyInfo.projectCode}}</div>
          </div>
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">下单公司</div>
            <div class="projectApply-info-value">{{projectApplyInfo.orderCompany}}</div>
          </div>
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">合作金额</div>
            <div class="projectApply-info-value">{{projectApplyInfo.proIncomeBudget|NumFormat}}元</div>
          </div>
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">项目地点</div>
            <div class="projectApply-info-value">{{projectApplyInfo.projectAddress}}</div>
          </div>
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">项目期限</div>
            <div
              class="projectApply-info-value"
            >{{projectApplyInfo.proStartDate}}至{{projectApplyInfo.proEndDate}}</div>
          </div>
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">项目负责人</div>
            <div class="projectApply-info-value">
              <div class="selected-box">
                <div @click="openProfile(projectApplyInfo.pMEmployeeDingId)" class="selected-item">
                  <img
                    class="headimg"
                    :src="projectApplyInfo.pMEmployeeHead&&projectApplyInfo.pMEmployeeHead.length>0?projectApplyInfo.pMEmployeeHead:require('@/assets/images/defaultHead.png')"
                  >
                  <label>{{projectApplyInfo.pMEmployeeName}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">项目组成员</div>
            <div class="projectApply-info-value">
              <div class="selected-box">
                <div
                  v-for="(item,index) in projectApplyInfo.teamMember"
                  :key="index"
                  class="selected-item"
                >
                  <img
                    @click="openProfile(item.dingDingId)"
                    class="headimg"
                    :src="item.proMemEmployeeHeadPath&&item.proMemEmployeeHeadPath.length>0?item.proMemEmployeeHeadPath:require('@/assets/images/defaultHead.png')"
                  >
                  <label>{{item.proMemEmployeeName}}</label>
                </div>
              </div>
            </div>
          </div>        
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">预估净利润</div>
            <div
              v-if="projectApplyInfo.expenditureBudget&&projectApplyInfo.expenditureBudget.totalAmount"
              class="projectApply-info-value"
            >{{(projectApplyInfo.proIncomeBudget-projectApplyInfo.expenditureBudget.totalAmount)|NumFormat}}元</div>
          </div>
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">利润率</div>
            <div
              v-if="projectApplyInfo.expenditureBudget&&projectApplyInfo.expenditureBudget.totalAmount"
              class="projectApply-info-value"
            >{{(((projectApplyInfo.proIncomeBudget-projectApplyInfo.expenditureBudget.totalAmount)/projectApplyInfo.proIncomeBudget)*100)|NumFormat}}%</div>
          </div>
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">项目说明</div>
            <div
              class="projectApply-info-value"
              v-html="$options.filters.textareaToFormat(projectApplyInfo.projectRemark)"
            ></div>
          </div>
          <div class="projectApply-info-box">
            <div class="projectApply-info-label">方案书</div>
            <div class="projectApply-info-value">
              <filebox message="暂无方案书相关文档" :fileInfo="fileInfo"></filebox>
            </div>
          </div>
        </div>
        <!--项目人工投入信息开始-->
        <div v-if="projectApplyInfo.workDoneInput&&projectApplyInfo.workDoneInput.salesman">
          <div class="divide-line"></div>
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">人工投入</div>
              <div class="purchase-order-Total">
                总时长
                <span>{{(projectApplyInfo.workDoneInput.salesman+projectApplyInfo.workDoneInput.agencyChannel+projectApplyInfo.workDoneInput.operate+projectApplyInfo.workDoneInput.synthesize+projectApplyInfo.workDoneInput.activity+projectApplyInfo.workDoneInput.creativePlanning+projectApplyInfo.workDoneInput.contentGather)|NumFormat}}小时</span>
              </div>
              <div class="ReimItem-content">
                <div class="ReimItem-box">
                  <div class="ReimItem">
                    <div class="ReimItem-label">销售人员</div>
                    <div class="ReimItem-vlue">{{projectApplyInfo.workDoneInput.salesman}}小时</div>
                    <div class="ReimItem-label">代理渠道支持</div>
                    <div class="ReimItem-vlue">{{projectApplyInfo.workDoneInput.agencyChannel}}小时</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">运营支持</div>
                    <div class="ReimItem-vlue">{{projectApplyInfo.workDoneInput.operate}}小时</div>
                    <div class="ReimItem-label">综合支持</div>
                    <div class="ReimItem-vlue">{{projectApplyInfo.workDoneInput.synthesize}}小时</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">活动支持</div>
                    <div class="ReimItem-vlue">{{projectApplyInfo.workDoneInput.activity}}小时</div>
                    <div class="ReimItem-label">创意策划</div>
                    <div class="ReimItem-vlue">{{projectApplyInfo.workDoneInput.creativePlanning}}小时</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">内容采编</div>
                    <div
                      style="border-right:0"
                      class="ReimItem-vlue"
                    >{{projectApplyInfo.workDoneInput.contentGather}}小时</div>
                    <div style="border-right:0" class="ReimItem-label"></div>
                    <div class="ReimItem-vlue"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--项目人工投入信息结束-->

        <!--项目支出预算明细开始-->
        <div
          v-if="projectApplyInfo.expenditureBudget!=null&&projectApplyInfo.expenditureBudget.projectExpenditureBudgets!=null&&projectApplyInfo.expenditureBudget.projectExpenditureBudgets.length>0"
        >
          <div class="divide-line"></div>
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">支出预算</div>
              <div class="purchase-order-Total">
                总金额
                <span>{{projectApplyInfo.expenditureBudget.totalAmount|NumFormat}}元</span>
              </div>
              <div class="ReimItem-content">
                <div class="ReimItem-box1">
                  <div
                    class="ReimItem1"
                    v-for="(expenditureItem,index) in projectApplyInfo.expenditureBudget.projectExpenditureBudgets"
                    :key="index+400"
                  >
                    <div class="ReimItem-vlue1">{{expenditureItem.budgetName}}</div>
                    <div class="ReimItem-label1">{{expenditureItem.budgetAmount|NumFormat}}元</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--项目支出预算明细结束-->

        <!--项目收入预算明细开始-->
        <div
          v-if="projectApplyInfo.revenueBudget!=null&&projectApplyInfo.revenueBudget.projectRevenueBudgets!=null&&projectApplyInfo.revenueBudget.projectRevenueBudgets.length>0"
        >
          <div class="divide-line"></div>
          <div class="purchaseInfo-content">
            <div class="purchase-order">
              <div class="purchase-order-label">收入预算</div>
              <div class="purchase-order-Total">
                总金额
                <span>{{projectApplyInfo.revenueBudget.totalAmount|NumFormat}}元</span>
              </div>
              <div
                v-for="(revenueItem,index) in projectApplyInfo.revenueBudget.projectRevenueBudgets"
                :key="index+200"
                class="ReimItem-content"
              >
                <div class="ReimItem-box">
                  <div class="ReimItem">
                    <div class="ReimItem-label">合同名称</div>
                    <div class="ReimItem-vlue">{{revenueItem.contractName}}</div>
                    <div class="ReimItem-label">合同金额</div>
                    <div
                      style="color: #333333;"
                      class="ReimItem-label"
                    >{{revenueItem.contractAmount|NumFormat}}元</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">收入名称</div>
                    <div class="ReimItem-vlue">{{revenueItem.budgetName}}</div>
                  </div>
                  <div class="ReimItem">
                    <div class="ReimItem-label">收入说明</div>
                    <div class="ReimItem-vlue">{{revenueItem.budgetComment}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--项目收入预算明细结束-->
        <!--备注开始-->
        <div class="divide-line"></div>
        <div class="purchaseInfo-content">
          <div class="purchase-order">
            <div class="ReimItem-content">
              <div style="border: 0" class="ReimItem-box">
                <div style="border: 0" class="ReimItem">
                  <div style="border: 0;align-items: self-end;padding: 0.13rem; " class="ReimItem-label">备注</div>
                  <div
                    v-html="$options.filters.textareaToFormat(projectApplyInfo.budgetRemark)"
                    style="border: 0;justify-content:left; align-items: self-end;"
                    class="ReimItem-vlue"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--备注结束-->
        <div class="divide-line"></div>
      </div>
      <div class="process d_jump">
        <process
          :approvalList="projectApplyInfo.approvalList"
          :applyEmployeeID="projectApplyInfo.applyEmployeeID"
        ></process>
      </div>
    </div>
    <div class="projectApply-foot">
      <exefoot
        :paramInfo="{...paramInfo,approveStep:projectApplyInfo.nextApproveStep}"
        v-if="projectApplyInfo.nextApproverId&&projectApplyInfo.nextApproverId.indexOf(userInfo.employeeID)>-1&&projectApplyInfo.applyStatus=='SUBMIT'"
      ></exefoot>
      <selffoot
        :paramInfo="paramInfo"
        :urgeInfo="{approverUserId:projectApplyInfo.nextApproverUserId,applyEmployeeName:projectApplyInfo.currentApplyEmployeeName, applyTypeName:'立项申请'}"
        v-else-if="projectApplyInfo.applyEmployeeID==userInfo.employeeID&&projectApplyInfo.applyStatus=='SUBMIT'"
      ></selffoot>
      <passfoot :paramInfo="paramInfo" v-else></passfoot>
    </div>
  </div>
</template>

<script>
import liteProcess from "@/components/Approval/ApprovalProcess/approvalProcess_Lite";
import headers from "@/components/Approval/ApprovalHead/index";
import tab from "@/components/Share/Tab";
import process from "@/components/Approval/ApprovalProcess/index";
import exefoot from "@/components/Approval/ApprovalFoot/approvalExeFoot";
import selffoot from "@/components/Approval/ApprovalFoot/approvalSelfFoot";
import passfoot from "@/components/Approval/ApprovalFoot/approvalPassFoot";
import filebox from "@/components/Share/Preview/fileBox";
import { mapState, mapMutations } from "vuex";
import http from "@/utils/http";
import * as dd from "dingtalk-jsapi";
export default {
  data() {
    return {
      paramInfo: {},
      projectApplyInfo: {},
      fileInfo: {},
      tabconfig: {
        defaultValue: 0,
        backFun: this.tabClickBackFun,
        affixNum: 0,
        tabList: [{ key: 0, value: "申请信息" }, { key: 1, value: "审批信息" }]
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      dingdingconfig: state => state.dingdingconfig
    })
  },
  methods: {
    ...mapMutations(["setTitleInfo"]),
    tabClickBackFun(index) {},
    getProjectApplyInfo(applyId, applyTypeId) {
      let _this = this;
      this.$Spin.show();
      return new Promise((resolve, reject) => {
        http
          .get(
            `/api/BD/Project/GetProjectApplyInfo?applyId=${applyId}&applyTypeId=${applyTypeId}`
          )
          .then(res => {
            _this.$Spin.hide();
            if (res.data && res.data.data) {
              _this.setTitleInfo({
                title: "",
                bg: res.data.data.applyStatus,
                isMore: true
              });
              _this.fileInfo = {
                filesrcs: res.data.data.proFilePath,
                filenames: res.data.data.proFileName
              };
              resolve(res.data.data || {});
            } else resolve({});
          });
      });
    },
    openProfile(dingdingUserId) {
      if (dingdingUserId.length > 0) {
        let _this = this;
        dd.biz.util.open({
          name: "profile", //页面名称
          params: { id: dingdingUserId, corpId: _this.dingdingconfig.corpId }, //传参
          onSuccess: function() {
            /**/
          },
          onFail: function(err) {}
        });
      }
    }
  },
  async mounted() {
    let _this = this;
    this.$nextTick(() => {
      _this.tabconfig.affixNum = _this.$refs.projectApply_content.offsetTop - 1;
      _this.$refs.projectApply_tab.style =
        "top:" + _this.tabconfig.affixNum + "px";
    });
    this.paramInfo = { ...this.$route.query };
    this.projectApplyInfo = await this.getProjectApplyInfo(
      this.paramInfo.applyId,
      this.paramInfo.applyTypeId
    );
  },
  components: {
    liteProcess,
    headers,
    tab,
    process,
    exefoot,
    selffoot,
    passfoot,
    filebox
  }
};
</script>

<style lang="less" scoped>
.projectApply-box {
  .projectApply-headers {
    padding: 0 0.4rem;
  }

  .projectApply-tab {
    width: 100%;
    height: 1.44rem;
    position: sticky;
    z-index: 9;
    background: #fff;
    display: flex;
    align-items: center;
  }
  .mian-box {
    padding-bottom: 1.6rem;
    .projectApply-info {
      .projectApply-info-content {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .projectApply-info-box {
          margin-top: 0.533333rem;
          font-size: 0.373333rem;
          display: flex;
          .projectApply-info-label {
            text-align: center;
            flex: 1;
            color: #999;
          }
          .projectApply-info-value {
            margin-left: 0.2rem;
            width: 76%;
            color: #333333;
            .selected-box {
              height: auto;
              display: flex;
              flex-wrap: wrap;
              .selected-item {
                height: 0.8rem;
                margin-right: 0.4rem;
                font-size: 0.346667rem;
                img {
                  vertical-align: middle;
                }
                .headimg {
                  width: 0.533333rem;
                  height: 0.533333rem;
                  margin-right: 0.133333rem;
                  border-radius: 50%;
                }
                label {
                  vertical-align: middle;
                }
                .delete-bnt {
                  width: 0.2rem;
                  height: 0.2rem;
                }
              }
            }
          }
        }
      }
      .divide-line {
        width: 100%;
        height: 0.133333rem;
        background: #f5f5f5;
      }
      .purchaseInfo-content {
        padding: 0 0.4rem;
        margin-bottom: 0.266667rem;
        .purchase-order {
          .purchase-order-Total {
            height: 1.44rem;
            line-height: 1.44rem;
            font-size: 0.373333rem;
            color: #999999;
            padding-left: 0.4rem;
            span {
              color: #333333;
            }
          }
          .purchase-order-label {
            height: 1.253333rem;
            line-height: 1.253333rem;
            font-size: 0.453333rem;
            color: #333333;
            font-weight: bold;
            border-bottom: 1px solid #eee;
          }
          .ReimItem-content {
            margin-top: 0.533333rem;
            .ReimItem-box1 {
              display: flex;
              flex-wrap: wrap;
              border-right: 1px solid #eee;
              border-bottom: 1px solid #eee;
              color: #333333;
              .ReimItem1 {
                width: 50%;
                display: flex;
                border-left: 1px solid #eee;
                .ReimItem-label1 {
                  width: 2.5rem;
                  border-top: 1px solid #eee;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
                .ReimItem-vlue1 {
                  border-top: 1px solid #eee;
                  flex: 1;
                  padding: 0.13rem;
                  border-right: 1px solid #eee;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  min-height: 1.066667rem;
                }
              }
            }
            .ReimItem-box {
              border-bottom: 1px solid #eee;
              .ReimItem {
                display: flex;
                border-left: 1px solid #eee;
                .ReimItem-label {
                  width: 2rem;
                  color: #999;
                  border-top: 1px solid #eee;
                }
                .ReimItem-vlue {
                  border-top: 1px solid #eee;
                  flex: 1;
                  color: #333333;
                  padding: 0.13rem;
                }
                div {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  min-height: 1.066667rem;
                  border-right: 1px solid #eee;
                }
              }
            }
          }
        }
      }
    }
    .process {
      margin-top: 0.4rem;
      padding: 0 0.4rem;
    }
  }
  .projectApply-foot {
    padding: 0 0.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.6rem;
    background: #fff;
    z-index: 9;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/BD/Project/ProjrctApply.vue